__turbopack_context__.v({
  "checked": "checkmark-module__HPXP7G__checked",
  "checkmark": "checkmark-module__HPXP7G__checkmark",
  "disabled": "checkmark-module__HPXP7G__disabled",
  "indeterminateMark": "checkmark-module__HPXP7G__indeterminateMark",
  "interactive": "checkmark-module__HPXP7G__interactive",
});
